import { Backdrop, CircularProgress } from "@mui/material";
import api from "api/api";
import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import useModalStore from "zustand/zustandstore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

const SectionUpdate = ({ modal, setIsuploadmodal, fetchBasicData, dropdownData, cards, setSeverity, setOpen, setAlertMessage }) => {
  const [templateName, setTemplateName] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [sectionsData, setSectionsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const mydata = useModalStore();

  const templates = Object.keys(cards.reduce((acc, obj) => ({ ...acc, ...obj }), {}));
  const availableSections = selectedTemplate ? Object.keys(cards.find(obj => obj[selectedTemplate])?.[selectedTemplate] || {}) : [];

  const formatSection = (section) => {
  if (!section) return "";

  const overrides = {
    HnP: "History & Physical",
    soap_note: "SOAP Note",
  };

  return overrides[section] || section
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

  

  const handleAddSection = () => {
    setSectionsData(prev => [...prev, { section_name: "", file: null, template_prompt: "" }]);
  };

  const handleSectionChange = (index, value) => {
    const updated = [...sectionsData];
    updated[index].section_name = value;
    updated[index].file = null;
    updated[index].template_prompt = "";
    setSectionsData(updated);
  };

  const handleDrop = (index, acceptedFiles) => {
    if (acceptedFiles.length) {
      const updated = [...sectionsData];
      updated[index].file = acceptedFiles[0];
      setSectionsData(updated);
      extractimg(index, acceptedFiles[0], updated[index].section_name);
    }
  };

  const extractimg = async (index, img, section) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", img);

      const config = {
        headers: { "Content-Type": "multipart/form-data" },
        params: section ? { section_name: section } : {},
      };

      const uploadedFile = await api.post(`/v1/user_templates/template_extraction`, formData, config);
      if (uploadedFile.status === 200) {
        const updated = [...sectionsData];
        updated[index].template_prompt = uploadedFile?.output || '';
        setSectionsData(updated);
        setAlertMessage("Template Extraction Successful");
        setSeverity("success");
      } else {
        setAlertMessage("Something went wrong");
        setSeverity("error");
      }
      setOpen(true);
    } catch (error) {
      console.error("Error:", error);
      setSeverity("error");
      setAlertMessage("Something went wrong");
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const isUploadEnabled =
  templateName &&
  sectionsData.length > 0 &&
  sectionsData.every(s => s.section_name && s.template_prompt);


  const handleSave = async () => {



       setSubmit(true);
    try {
    
      const updatedSectionsData = sectionsData.map(section => {
        const { file, ...updatedSection } = section; // Destructure to exclude 'file' key
        return updatedSection; // Return the object without 'file'
      });
      const payload = {
        template_name: templateName,
        "base_template":selectedTemplate?.toLowerCase(),
         "sections":updatedSectionsData
      };

     
      const response = await api.post('/v1/user_templates/save_template', payload);
      if (response.status === 200) {
        setAlertMessage("Template saved successfully");
        setSeverity("success");
        setOpen(true);
      } else {
        throw new Error();
      }
    } catch (error) {
      console.error(error);
      setAlertMessage("Failed to save template");
      setSeverity("error");
      setOpen(true);
    } finally {
      setSubmit(false);
      fetchBasicData();
      setTemplateName("");
      setSelectedTemplate("");
      setSectionsData([]);
      setIsuploadmodal(false);
      window.location.reload();
    }
  };

  if (!modal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white min-h-[80vh] w-[95%] lg:w-[80%] max-h-[90vh] overflow-y-auto rounded-md shadow-2xl p-6">
        <h2 className="text-2xl font-bold text-[#1c2a3a] mb-4">Upload Template</h2>

        <div className="flex flex-col lg:flex-row gap-6  ">
          {/* Left Side – Template Info */}
          <div className="lg:w-1/3 space-y-4">
            <div>
              <label className="block text-sm text-start font-medium text-[#1c2a3a]">Template Name</label>
              <input
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-[#1c2a3a]"
                value={templateName}
                onChange={(e) => setTemplateName(e.target.value)}
              />
            </div>
  
            {mydata.usertype === 'PRO' && (
              <div>
                <label className="block text-sm  text-start font-medium text-[#1c2a3a]">Select Template</label>
                <select
                  className="mt-1 block w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-[#1c2a3a]"
                  value={selectedTemplate}
                  onChange={(e) => {
                    setSelectedTemplate(e.target.value);
                    setSectionsData([]);
                  }}
                >
                  <option value="">Choose Template</option>
                  {templates
                    // .filter(t => t === 'HnP' || t === 'soap_note')
                    .map((template) => (
                      <option key={template} value={template}>
                        {formatSection(template)}
                      </option>
                    ))}
                </select>
              </div>
            )}
  
            {selectedTemplate&&
            <div className=" "><button
              onClick={handleAddSection}
              className="w-full text-start gap-2 text-sm font-medium text-blue-600 hover:underline"
            >
              <FontAwesomeIcon icon={faPlus} /> Add Section
            </button></div>}
            <div className="flex gap-4 justify-end">
            <button
            onClick={() => {
              setIsuploadmodal(false);
              setTemplateName("");
              setSelectedTemplate("");
              setSectionsData([]);
            }}
            className="px-4 py-2 bg-gray-200 text-gray-800 text-sm font-semibold rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            disabled={!isUploadEnabled}
            onClick={handleSave}
            className={`px-4 py-2 text-sm font-semibold rounded-md transition-all ${
              isUploadEnabled
                ? "bg-[#1C2A3A] text-white hover:bg-[#16222F]"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          >
            Upload
          </button>
            </div>
          </div>
  
          {/* Right Side – Sections List */}
          <div className="lg:w-2/3 space-y-6">
            {sectionsData?.length?sectionsData.map((sectionItem, index) => (
              <div key={index} className="bg-gray-50 shadow-md rounded-md p-4">
                <div className="flex justify-between items-center mb-2">
                  <label className="font-semibold text-sm text-[#1c2a3a]">Section {index + 1}</label>
                  <button
                    onClick={() => setSectionsData(sectionsData.filter((_, i) => i !== index))}
                    className="text-red-500 hover:text-red-700"
                    title="Remove Section"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
  
                <select
                  className="w-full border rounded-md p-2 text-sm mb-3 focus:ring-2 focus:ring-[#1c2a3a]"
                  value={sectionItem.section_name}
                  onChange={(e) => handleSectionChange(index, e.target.value)}
                >
                  <option value="">Select Section</option>
                  {availableSections.map((section) => {
  // Check if the section_name in the array of objects matches the current section value
  const isDisabled = sectionsData?.some(obj => obj.section_name === section);

  return (
    <option key={section} value={section} disabled={isDisabled}>
      {formatSection(section)}
    </option>
  );
})}

                </select>
  
                {sectionItem.template_prompt? (
                  <textarea
                    className="w-full border rounded-md p-2 text-sm resize-none h-28"
                    value={sectionItem.template_prompt}
                    onChange={(e) => {
                      const updated = [...sectionsData];
                      updated[index].template_prompt = e.target.value;
                      setSectionsData(updated);
                    }}
                  />
                ) : (
                  <DropZone index={index} onDrop={handleDrop} />
                )}
              </div>
            )):
            
            <div className="flex justify-center items-center min-h-[100%] p-6 rounded-lg shadow-md">
            <p className="text-center text-xl font-semibold text-gray-800">
              {!templateName && 'Please enter a template name.'}
              {templateName && !selectedTemplate && 'Please select a template from the dropdown.'}
              {templateName && selectedTemplate && 'Please add a section using the + Add Section.'}
            </p>
          </div>
          
          
            
            }
          </div>
        </div>
  
      
   
  
        <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
          <div className="text-white font-mono text-xl font-bold">Extracting Text...</div>
        </Backdrop>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={submit}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );
  
};

const DropZone = ({ index, onDrop }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: { "application/pdf": [".pdf"], "image/png": [".png"], "image/jpeg": [".jpeg", ".jpg"] },
    onDrop: (acceptedFiles) => onDrop(index, acceptedFiles),
  });

  return (
    <div {...getRootProps()} className="border border-dashed border-gray-400 p-6 rounded-md flex flex-col items-center cursor-pointer hover:bg-gray-100 transition-all">
      <input {...getInputProps()} />
      <p className="text-sm text-gray-500">Drag & drop or click to upload</p>
      <button className="mt-2 px-4 py-1 bg-[#1c2a3a] text-white text-sm rounded-md">Browse</button>
    </div>
  );
};

export default SectionUpdate;
